import { OneDecimalPlace } from '../../../helpers/Helpers';

export const totalWeeksOfSelectedQuarter = (rowArr, quarterIdx: number): number => {
  return rowArr[0].quarters[quarterIdx].weeks.length + 1;
};

export const calculateGrandTotal = (rowArr, type: string) => {
  const total = rowArr.reduce((rInit, row) => {
    rInit += row.quarters
      .reduce((qInit, quarter) => {
        qInit += quarter.weeks.reduce((wInit, week) => {
          wInit += week[type === 'Units' ? 'unit_value' : 'revenue_value'];
          return wInit;
        }, 0);
        return qInit;
      }, 0);
    return rInit;
  }, 0);

  return type === 'Units' ? Math.round(total) : Math.round(total);
};

export const calculateGrandTotalComparision = (rowArr, type: string, comparisionType: string) => {
  if (comparisionType === '') {
    return 0;
  }

  const total = rowArr.reduce((rInit, row) => {
    rInit += row.quarters
      .filter((quarter) => !quarter.isPast)
      .reduce((qInit, quarter) => {
        qInit += quarter.weeks.reduce((wInit, week) => {
          wInit += week[type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`];
          return wInit;
        }, 0);
        return qInit;
      }, 0);
    return rInit;
  }, 0);

  return type === 'Units' ? Math.round(total) : Math.round(total);
};

export const calculateProductGrandTotal = (quarterArr, type: string) => {
  const total = quarterArr
    .reduce((acc, quarter) => {
      acc += quarter.weeks.reduce((init, week) => {
        init += week[type === 'Units' ? 'unit_value' : 'revenue_value'];
        return init;
      }, 0);
      return acc;
    }, 0);

  return type === 'Units' ? Math.round(total) : Math.round(total);
};

export const calculateProductGrandTotalComparision = (quarterArr, type: string, comparisionType: string) => {
  if (comparisionType === '') {
    return 0;
  }

  const total = quarterArr
    .filter((quarter) => !quarter.isPast)
    .reduce((acc, quarter) => {
      acc += quarter.weeks.reduce((init, week) => {
        init += week[type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`];
        return init;
      }, 0);
      return acc;
    }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateQuarterTotal = (weekArr, type: string) => {
  const total = weekArr.reduce((acc, week) => {
    acc += week[type === 'Units' ? 'unit_value' : 'revenue_value'];
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateQuarterTotalComparision = (weekArr, type: string, comparisionType: string) => {
  const total = weekArr.reduce((acc, week) => {
    acc += week[type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`];
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateVerticalTotal = (rowArr, type: string) => {
  const total = rowArr.reduce((rInit, row) => {
    rInit += row.value;
    return rInit;
  }, 0);

  return type === 'Units' ? Math.round(total) : Math.round(total);
};

export const calculateVerticalQuarterTotal = (rowArr, quarterIdx: number, type: string) => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].weeks.reduce((init, week) => {
      init += week[type === 'Units' ? 'unit_value' : 'revenue_value'];
      return init;
    }, 0);
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : Math.round(total);
};

export const calculateVerticalQuarterTotalComparision = (rowArr, quarterIdx: number, type: string, comparisionType: string) => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].weeks.reduce((init, week) => {
      init += week[type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`];
      return init;
    }, 0);
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateVerticalWeekTotal = (rowArr, quarterIdx: number, weekIdx: number, type: string) => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].weeks[weekIdx]
      ? row.quarters[quarterIdx].weeks[weekIdx][type === 'Units' ? 'unit_value' : 'revenue_value']
      : 0;
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculateVerticalWeekTotalComparision = (rowArr, quarterIdx: number, weekIdx: number, type: string, comparisionType: string) => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].weeks[weekIdx]
      ? row.quarters[quarterIdx].weeks[weekIdx][type === 'Units' ? `unit_${comparisionType}` : `revenue_${comparisionType}`]
      : 0;
    return acc;
  }, 0);

  return type === 'Units' ? Math.round(total) : OneDecimalPlace(total);
};

export const calculatePercentageValue = (value: number, total: number) => {
  return total !== 0 ? parseFloat(OneDecimalPlace((value / total) * 100).toString()) : 0;
};

export const calculateHorizontalQuarterPct = (rowArr, rowIdx) => {
  return rowArr[rowIdx].quarters.reduce((acc, quarter) => {
    acc += quarter.pctValue;
    return acc;
  }, 0);
};

export const calculateVerticalTotalPct = (rowArr) => {
  return rowArr.reduce((acc, row) => {
    acc += row.pctValue;
    return acc;
  }, 0);
};

export const calculateVerticalQuarterPct = (rowArr, quarterIdx) => {
  return rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].pctValue;
    return acc;
  }, 0);
};

export const calculateVerticalWeekPct = (rowArr, quarterIdx: number, weekIdx: number): number => {
  return rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].weeks[weekIdx] ? row.quarters[quarterIdx].weeks[weekIdx].pctValue : 0;
    return acc;
  }, 0);
};

export const calculateQuarterPct = (rowArr, rowIdx: number, quarterIdx: number): number => {
  return rowArr[rowIdx].quarters[quarterIdx].weeks.reduce((acc, week) => {
    acc += week.pctValue;
    return acc;
  }, 0);
};

export const calculateTotalVerticalEdit = (rowArr): number => {
  const total = rowArr
    .filter((row) => row.isEdited)
    .reduce((acc, row) => {
      acc += row.pctValue;
      return acc;
    }, 0);

  return Math.round(total);
};

export const calculateTotalVerticalQuarterEdit = (rowArr, quarterIdx: number): number => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].isEdited ? row.quarters[quarterIdx].pctValue : 0;
    return acc;
  }, 0);

  return Math.round(total);
};

export const calculateTotalVerticalWeekEdit = (rowArr, quarterIdx: number, weekIdx: number): number => {
  const total = rowArr.reduce((acc, row) => {
    acc += row.quarters[quarterIdx].weeks[weekIdx]
      ? (row.quarters[quarterIdx].weeks[weekIdx].isEdited ? row.quarters[quarterIdx].weeks[weekIdx].pctValue : 0)
      : 0;
    return acc;
  }, 0);

  return Math.round(total);
};

export const calculateTotalHorizontalQuarterEdit = (rowArr, rIdx: number) => {
  const total = rowArr[rIdx].quarters
    .filter((quarter) => !quarter.isPast)
    .reduce((qInit, quarter) => {
      qInit += quarter.isEdited ? quarter.pctValue : 0;
      return qInit;
    }, 0);

  return Math.round(total);
};

export const calculateTotalHorizontalWeekEdit = (rowArr, rIdx: number) => {
  const total = rowArr[rIdx].quarters
    .filter((quarter) => !quarter.isPast)
    .reduce((qInit, quarter) => {
      qInit += quarter.weeks.reduce((wInit, week) => {
        wInit += week.isEdited ? week.pctValue : 0;
        return wInit;
      }, 0);
      return qInit;
    }, 0);

  return Math.round(total);
};

export const calculateHorizontalPrevValue = (quarters, type: string): number => {
  const total = quarters
    .filter((quarter) => !quarter.isPast)
    .reduce((acc, value) => {
      acc += value.oldValue;
      return acc;
    }, 0);

  return type === 'Units' ? Math.round(total) : Math.round(total);
};

export const calculateHorizontalWeekPrevValue = (weeks, type: string): number => {
  const total = weeks
    .reduce((acc, value) => {
      acc += value.oldValue;
      return acc;
    }, 0);

  return type === 'Units' ? Math.round(total) : Math.round(total);
};

export const checkIfAllQuartersArePast = (quarters): boolean => {
  return quarters.reduce((acc, value) => acc && value.isPast, true);
};
